import { useState, useEffect } from 'react';
import { B as BreakpointSm, a as BreakpointMd, b as BreakpointLg, c as BreakpointXl, d as BreakpointXxl } from './primitive-DEjVLxOV.js';

function breakpoint(name, min, max) {
  if (globalThis.visualViewport == null) {
    return void 0;
  }
  if ((min == null || globalThis.visualViewport?.width >= min) && (max == null || globalThis.visualViewport?.width < max)) {
    return {
      name,
      min,
      max,
      orientation: globalThis.visualViewport?.height > globalThis.visualViewport?.width ? "portrait" : "landscape",
      innerWidth: globalThis.visualViewport?.width,
      innerHeight: globalThis.visualViewport?.height
    };
  }
  return void 0;
}
const onResize = () => {
  if (!BreakpointSm) return;
  if (!BreakpointMd) return;
  if (!BreakpointLg) return;
  if (!BreakpointXl) return;
  if (!BreakpointXxl) return;
  const sm = parseInt(BreakpointSm.value);
  const md = parseInt(BreakpointMd.value);
  const lg = parseInt(BreakpointLg.value);
  const xl = parseInt(BreakpointXl.value);
  const xxl = parseInt(BreakpointXxl.value);
  return breakpoint("xs", void 0, sm) ?? breakpoint("sm", sm, md) ?? breakpoint("md", md, lg) ?? breakpoint("lg", lg, xl) ?? breakpoint("xl", xl, xxl) ?? breakpoint("xxl", xxl, void 0);
};
const useBreakpoint = (props) => {
  const [size, setSize] = useState(onResize());
  useEffect(() => {
    if (props?.disable) return;
    const updateSize = () => {
      setSize(onResize());
    };
    globalThis.addEventListener("resize", updateSize);
    return () => {
      globalThis.removeEventListener("resize", updateSize);
    };
  }, []);
  if (props?.disable) return;
  return size;
};

export { useBreakpoint as u };
//# sourceMappingURL=useBreakpoint-7QkBkSeP-CfR8YWax.js.map
